export default __webpack_public_path__ + "static/media/asset lock.44aa4f71.png";